if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const complementaryItems = this.getSelectedComplementaryItems();

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) {
                return Promise.reject(new Error(response.description || 'Add to cart failed'));
              }

              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;

              return Promise.reject(new Error(response.description || 'Add to cart failed'));
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return Promise.reject(new Error('Redirecting to cart'));
            }

            return Promise.resolve(response).then((mainResponse) => {
              return this.addComplementaryItems(complementaryItems).then(() => mainResponse);
            });
          })
          .then((response) => {
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((res) => res.text())
                .then((htmlText) => {
                  const html = new DOMParser().parseFromString(htmlText, 'text/html');
                  const drawerInner = html.querySelector('#CartDrawer');
                  const bubble = html.querySelector('#shopify-section-cart-icon-bubble');

                  if (drawerInner) {
                    const currentDrawer = document.querySelector('#CartDrawer');
                    if (currentDrawer) currentDrawer.innerHTML = drawerInner.innerHTML;
                  }

                  if (bubble) {
                    const currentBubble = document.querySelector('#shopify-section-cart-icon-bubble');
                    if (currentBubble) currentBubble.innerHTML = bubble.innerHTML;
                  }

                  if (this.cart && typeof this.cart.open === 'function') {
                    this.cart.open();
                  }
                });
            }

            return response;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      getSectionId() {
        return this.dataset.sectionId || this.getAttribute('data-section-id') || '';
      }

      getSelectedComplementaryItems() {
        const sectionId = this.getSectionId();
        if (!sectionId) return [];

        if (typeof window.ChtipopsGetSelectedComplementaryItems !== 'function') {
          return [];
        }

        try {
          return window.ChtipopsGetSelectedComplementaryItems(sectionId) || [];
        } catch (e) {
          console.error(e);
          return [];
        }
      }

      addComplementaryItems(items) {
        if (!items || !items.length) {
          return Promise.resolve(null);
        }

        return fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items }),
        }).then((response) => response.json());
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
